const Due = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3876_52713)">
      <path
        d="M9.99967 19.1666C15.0623 19.1666 19.1663 15.0625 19.1663 9.99992C19.1663 4.93731 15.0623 0.833252 9.99967 0.833252C4.93706 0.833252 0.833008 4.93731 0.833008 9.99992C0.833008 15.0625 4.93706 19.1666 9.99967 19.1666Z"
        fill="#1890FF"
        stroke="#1890FF"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 4.1665V9.99984H15.8333"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3876_52713">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default Due
